import { Button, FormGroup, InputLabel, OutlinedInput } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Container, ContainerForm, Title } from '../../styles/index.sty';
import AlertSnack from '../../components/Alert/AlertSnack'
import { useAuth } from '../../context/authContext'
import { useLists } from '../../context/listContext'
import { insertUserTypeData, updateUserTypeData } from '../../api/user-types.api'

export const AddUserType = () => {
  const { config } = useAuth();
  const { fetchUserTypesList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [ response, setResponse ] = useState({});
  const formik = useFormik({
    initialValues: {
    type: location?.state?.data?.type
    },
    onSubmit: async values => {
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateUserTypeData({...values, user_type_id: location?.state?.data?.user_type_id }, config);
        setResponse(submit);
        setOpen(true);
        fetchUserTypesList();
        if(submit.status === "success") {
          navigate("/user-types");
        }
      } else {
        const submit = await insertUserTypeData(values, config);
        setResponse(submit);
        fetchUserTypesList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/user-types");
        }
      }
    },
  });

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter User Type Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel htmlFor="type">User Type: </InputLabel>
          <OutlinedInput
            name="type"
            placeholder="Enter User Type"
            id="type"
            type="text"
            value={formik.values.type}
            onChange={formik.handleChange}
            />
        </FormGroup>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/user-types")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
        </div>}
      </ContainerForm>
    </Container>
    </>
  )
};